import { LitElement, html } from "lit";

import styles from "./element.css?lit";
import Button from "./pure.js";

export class MDNButton extends LitElement {
  static styles = styles;

  static get properties() {
    return {
      disabled: { type: Boolean },
      disabledReason: { type: String, attribute: "disabled-reason" },
      variant: { type: String },
      action: { type: String },
      icon: { state: true },
      iconOnly: { type: Boolean, attribute: "icon-only" },
      iconPosition: { type: String, attribute: "icon-position" },
      href: { type: String },
      target: { type: String },
      rel: { type: String },
    };
  }

  constructor() {
    super();
    this.disabled = false;
    this.disabledReason = "";
    /** @type {import("@lit").TemplateResult | undefined} */
    this.icon = undefined;
    this.iconOnly = false;
    /** @type {import("./types.js").ButtonIconPositions} */
    this.iconPosition = "before";
    /** @type {import("./types.js").ButtonVariants} */
    this.variant = "primary";
    /** @type {import("./types.js").ButtonActions} */
    this.action = undefined;
    /** @type {string | undefined} */
    this.href = undefined;
    /** @type {string | undefined} */
    this.target = undefined;
    /** @type {string | undefined} */
    this.rel = undefined;
  }

  /**
   * @param {MouseEvent} event
   */
  #click(event) {
    if (!this.href && this.disabled && this.disabledReason) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this.#click, { capture: true });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("click", this.#click, { capture: true });
  }

  render() {
    const title =
      !this.href && this.disabled && this.disabledReason
        ? this.disabledReason
        : undefined;
    return Button({
      label: html`<slot></slot>`,
      disabled: this.disabledReason ? false : this.disabled,
      ariaDisabled: this.disabledReason ? this.disabled : undefined,
      ariaDescription: title,
      title,
      icon: this.icon,
      iconOnly: this.iconOnly,
      iconPosition: this.iconPosition,
      variant: this.variant,
      action: this.action,
      href: this.href,
      target: this.target,
      rel: this.rel,
    });
  }
}

customElements.define("mdn-button", MDNButton);
